<template>
<div class="px-1 pt-1">
  <ScanInput :instruction="$t('page.delivery.form.deliveryCode')" :help-text="$t('page.delivery.form.deliveryCodeHelp')" @scanned="submitForm" class="input-group" />
  <DeliveryList @selected="goToDelivery" />
</div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useSessionStore, useDeliveriesStore } from '@/stores';
import { toast, type ToastOptions } from 'vue3-toastify';
import DeliveryList from "@/components/deliveries/DeliveryList.vue";
import { router } from "@/services";
import ScanInput from "@/components/form/ScanInput.vue";
import { useI18n } from 'vue-i18n';

const i18n = useI18n();

const sessionStore = useSessionStore();
const deliveriesStore = useDeliveriesStore();
const { delivery } = storeToRefs(deliveriesStore);
const { selectedSiteId } = storeToRefs(sessionStore);

const isLoading = ref(false);

const goToDelivery = async (deliveryId: number) => {
  await router.push({ name: 'delivery', params: { deliveryId: deliveryId } });
}

const submitForm = async (barcode: string) => {
  if (barcode.trim() === '') {
    return;
  }
  isLoading.value = true;
  const currentDelivery = deliveriesStore.getByCode(barcode.trim(), selectedSiteId.value);
  if (currentDelivery == undefined) {
    await deliveriesStore.fetchByCode(barcode.trim());
    if (delivery.value !== null) {
      await goToDelivery(delivery.value.id);
    }
    else {
      toast.error(i18n.t('page.delivery.deliveryNotFoundError', { deliveryCode: barcode }), { autoClose: false, theme: 'colored' } as ToastOptions);
    }
  }
  else {
    await goToDelivery(currentDelivery.id);
  }

  isLoading.value = false;
};
</script>
